import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartnerService } from 'src/app/shared/services/partner.service';


@Component({
  selector: 'app-data-management-create-episode-info-modal',
  templateUrl: './data-management-create-episode-info-modal.component.html',
  styleUrls: ['./data-management-create-episode-info-modal.component.scss']
})
export class DataManagementCreateEpisodeInfoModalComponent implements OnInit {

  season;
  episodeNumber;
  title;
  partnerGroupId: null;
  selectedPartnerGroup: any;
  partnerGroups;
  selectedEpisode = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DataManagementCreateEpisodeInfoModalComponent>,
    private partnerService: PartnerService
    ) {
      this.season = data.season;
      this.partnerGroups = data.partnerGroups;
      if (data.episode) {
        // a copy: nothing done in this form reaches the table's row unless Save Episode succeeds
        this.selectedEpisode = JSON.parse(JSON.stringify(data.episode));
      }
     }

  ngOnInit() {
    if (this.selectedEpisode) {
      this.episodeNumber = this.selectedEpisode.episode_number;
      this.title = this.selectedEpisode.title;
      // this.partnerGroupId = this.selectedEpisode.partnerGroup_id;
      this.selectedPartnerGroup = this.findPartnerGroup(this.selectedEpisode.partnerGroup_id);
    }
  }

  trackById(_: number, item: any) {
    return item.id;
  }

  close(): void {
    this.dialogRef.close();
  }

  createProEpisode(seasonId) {
    if (this.selectedEpisode) {
      this.partnerService.updateProEpisode(this.selectedEpisode.id, seasonId, this.episodeNumber, this.title, this.selectedPartnerGroup.id).subscribe((res: any) => {
        // hand the saved row (with its id) back to the episode modal, which updates the table in place
        this.dialogRef.close(res);
      });
    }
    else {
      this.partnerService.updateProEpisode(null, seasonId, this.episodeNumber, this.title, this.selectedPartnerGroup.id).subscribe((res: any) => {
        // hand the saved row (with its id) back to the episode modal, which updates the table in place
        this.dialogRef.close(res);
      });
    }
  }

  // Method to find partner name based on ID
  findPartnerGroup(partnerId: number | null): string {
    const partnerGroup = this.partnerGroups.find(p => p.id === partnerId);
    if (partnerGroup) {
      return partnerGroup
    } else {
      return null;
    }
  }

}
